import { useState } from 'react';
import { faqs, topics } from '@/mocks/routeData';

export default function TopicFaq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      {/* 题材合集索引 */}
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-orange-400" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">COLLECTION · 按题材找</span>
          </div>
          <h2 className="font-mag mt-3 text-2xl font-black text-stone-900 md:text-4xl">挑个题材，合集都在</h2>
        </div>
        <p className="max-w-sm text-sm leading-6 text-stone-500 md:text-right">题材只是入口，里面的观看顺序与推荐路线都已排好。</p>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {topics.map((t) => (
          <a
            key={t.name}
            href="#order"
            className="group flex cursor-pointer flex-col items-center gap-3 rounded-2xl border border-stone-200/80 bg-white px-3 py-6 text-center transition hover:-translate-y-0.5 hover:border-orange-300"
          >
            <span className={`flex h-12 w-12 items-center justify-center rounded-full text-2xl ${t.tagClass}`}>
              <i className={t.emoji} />
            </span>
            <span className="text-sm font-bold text-stone-800">{t.name}</span>
            <span className="text-[11px] text-stone-400">顺序已整理</span>
          </a>
        ))}
      </div>

      {/* FAQ */}
      <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-orange-400" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-orange-600">FAQ</span>
          </div>
          <h2 className="font-mag mt-3 text-2xl font-black leading-snug text-stone-900 md:text-3xl">
            关于观看顺序与线路，常见的几个疑问
          </h2>
          <p className="mt-3 max-w-sm text-sm leading-6 text-stone-500">
            还没提到的问题，可以到社区提问，或点下方进入完整帮助页（静态示意）。
          </p>
          <button className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg bg-stone-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-orange-600">
            查看更多 FAQ <i className="ri-arrow-right-line" />
          </button>
        </div>

        <div className="lg:col-span-3">
          <div className="divide-y divide-stone-200 overflow-hidden rounded-2xl border border-stone-200/80 bg-white">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <button
                  key={f.q}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="block w-full cursor-pointer px-5 py-5 text-left md:px-6"
                >
                  <div className="flex items-center justify-between gap-3">
                    <h4 className="flex-1 text-sm font-bold text-stone-900 md:text-[15px]">
                      <span className="mr-2 font-mag text-orange-500">Q{i + 1}</span>
                      {f.q}
                    </h4>
                    <i
                      className={`shrink-0 text-lg text-stone-400 transition-transform ${isOpen ? 'rotate-45 text-orange-500' : ''} ri-add-line`}
                    />
                  </div>
                  {isOpen && <p className="float-in mt-3 pl-9 text-[13px] leading-6 text-stone-500">{f.a}</p>}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}